export default "__VITE_ASSET__ColDE1P6__"